<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import axios from "axios";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import VueApexCharts from "vue-apexcharts";
/**
 * Advanced table component
 */
export default {
  page: {
    title: "Transactions",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, DatePicker, apexchart: VueApexCharts },
  data() {
    return {
      title: "Transactions",
      items: [
        {
          text: "Admin",
          href: "/dashboard",
        },
        {
          text: "Transactions",
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "age",
      sortDesc: false,
      fields: [
        { key: "customerName", sortable: true, label: "Customer Name" },
        {
          key: "transactionData.changes.transactionDate",
          sortable: true,
          label: "Transaction Date",
        },
        {
          key: "transactionData.changes.transactionAmount",
          sortable: true,
          label: "Transaction Amount (GHS)",
        },
        {
          key: "paymentTypeId",
          sortable: true,
          label: "Payment Type",
        },
        { key: "agent.firstName", sortable: true, label: "Agent First Name" },
        { key: "agent.lastName", sortable: true, label: "Agent Last Name" },
        { key: "transactionType" },
        { key: "transactionPaymentType", label: "Individaul / Group" },
        { key: "notified" },
      ],
      /* data variables*/
      transactions: [],
      agents: [],
      selectedAgents: [],
      loading: false,
      searchQuery: "",
      selectedValues: [],
      individualOrGroup: [],
      paymentType: [],
      // date picker
      dateRange: [new Date(), new Date()],
      // date picker end
      // Chart toggle
      showChart: false,
    };
  },
  computed: {
    /**
     * Total no. of records
     */
    rows() {
      return this.transactions.length;
    },
    calculateTransactions() {
      return this.filterCustomer
        .filter(
          (transaction) =>
            transaction.transactionType !== "Withdrawal" &&
            transaction.transactionType !== "SavingsDeposit"
        )
        .reduce((accumulator, transaction) => {
          // Check if transactionData and changes exist before accessing transactionAmount
          if (
            transaction.transactionData &&
            transaction.transactionData.changes &&
            transaction.transactionData.changes.transactionAmount !== undefined
          ) {
            // Parse the transactionAmount to ensure it's a valid number
            const transactionAmount = parseFloat(
              transaction.transactionData.changes.transactionAmount
            );

            // Check if the parsed transactionAmount is a valid number
            if (!isNaN(transactionAmount)) {
              return accumulator + transactionAmount;
            }
          }

          // If any of the checks fail, return the accumulator unchanged
          return accumulator;
        }, 0.0);
    },
    momoTransactions() {
      return this.filterCustomer
        .filter((transaction) => {
          return (
            transaction.transactionType !== "Withdrawal" &&
            transaction.transactionData?.changes?.paymentTypeId === "2"
          );
        })
        .reduce((accumulator, transaction) => {
          return (
            accumulator +
            parseFloat(transaction.transactionData.changes.transactionAmount)
          );
        }, 0.0);
    },
    cashTransactions() {
      return this.filterCustomer
        .filter((transaction) => {
          return (
            transaction.transactionType !== "Withdrawal" &&
            transaction.transactionType !== "SavingsDeposit" &&
            transaction.transactionData?.changes?.paymentTypeId === "1"
          );
        })
        .reduce((accumulator, transaction) => {
          return (
            accumulator +
            parseFloat(transaction.transactionData.changes.transactionAmount)
          );
        }, 0.0);
    },
    cashWithdrawals() {
      return this.filterCustomer
        .filter((transaction) => {
          return (
            transaction.transactionType === "Withdrawal" &&
            transaction.transactionData?.changes?.paymentTypeId === "1"
          );
        })
        .reduce((accumulator, transaction) => {
          return (
            accumulator +
            parseFloat(transaction.transactionData.changes.transactionAmount)
          );
        }, 0.0);
    },
    cashCollaterals() {
      return this.filterCustomer
        .filter((transaction) => {
          return (
            transaction.transactionType === "SavingsDeposit" &&
            transaction.transactionData?.changes?.paymentTypeId === "1"
          );
        })
        .reduce((accumulator, transaction) => {
          return (
            accumulator +
            parseFloat(transaction.transactionData.changes.transactionAmount)
          );
        }, 0.0);
    },
    filterCustomer() {
      let filteredTransactions = [...this.transactions]; // Create a copy of transactions

      if (this.searchQuery !== "") {
        const searchQueryLowerCase = this.searchQuery.toLowerCase();
        filteredTransactions = filteredTransactions.filter((transaction) =>
          transaction?.customerName === undefined
            ? false
            : transaction.customerName
                .toLowerCase()
                .includes(searchQueryLowerCase)
        );
      }

      if (this.individualOrGroup.length > 0) {
        filteredTransactions = filteredTransactions.filter((transaction) =>
          this.individualOrGroup.includes(transaction.transactionPaymentType)
        );
      }

      if (this.selectedValues.length > 0) {
        filteredTransactions = filteredTransactions.filter((transaction) =>
          this.selectedValues.includes(transaction.transactionType)
        );
      }

      if (this.paymentType.length > 0) {
        filteredTransactions = filteredTransactions.filter((transaction) =>
          transaction?.transactionData?.changes?.paymentTypeId === undefined
            ? false
            : this.paymentType.includes(
                transaction.transactionData.changes.paymentTypeId
              )
        );
      }

      // Filter by selected agents
      if (this.selectedAgents.length > 0) {
        filteredTransactions = filteredTransactions.filter((transaction) => {
          // Handle different agent data structures
          let agentId = null;

          // Check if agent is an object with _id or id
          if (transaction.agent && typeof transaction.agent === "object") {
            agentId = transaction.agent._id || transaction.agent.id;
          } else if (typeof transaction.agent === "string") {
            // Agent is stored as string ID
            agentId = transaction.agent;
          }

          // Also check if agent info is stored elsewhere in transaction
          if (!agentId && transaction.agentId) {
            agentId = transaction.agentId;
          }

          // Check if agent info is in transactionData
          if (!agentId && transaction.transactionData?.agent) {
            if (typeof transaction.transactionData.agent === "object") {
              agentId =
                transaction.transactionData.agent._id ||
                transaction.transactionData.agent.id;
            } else {
              agentId = transaction.transactionData.agent;
            }
          }

          // Check if agent info is in transactionData.changes
          if (!agentId && transaction.transactionData?.changes?.agent) {
            if (typeof transaction.transactionData.changes.agent === "object") {
              agentId =
                transaction.transactionData.changes.agent._id ||
                transaction.transactionData.changes.agent.id;
            } else {
              agentId = transaction.transactionData.changes.agent;
            }
          }

          return agentId && this.selectedAgents.includes(agentId);
        });
      }

      return filteredTransactions;
    },

    // Transform transactions to include flattened paymentTypeId for table display
    transactionsForTable() {
      return this.filterCustomer.map((transaction) => ({
        ...transaction,
        paymentTypeId: transaction.transactionData?.changes?.paymentTypeId,
      }));
    },

    // Agent performance data for chart
    agentPerformanceData() {
      const agentStats = {};

      // Group filtered transactions by agent
      this.filterCustomer.forEach((transaction) => {
        let agentId = null;
        let agentName = "Unknown Agent";

        // Get agent ID and name
        if (transaction.agent && typeof transaction.agent === "object") {
          agentId = transaction.agent._id || transaction.agent.id;
          agentName =
            `${transaction.agent.firstName || ""} ${
              transaction.agent.lastName || ""
            }`.trim() || "Unknown Agent";
        } else if (typeof transaction.agent === "string") {
          agentId = transaction.agent;
          // Find agent name from agents array
          const foundAgent = this.agents.find(
            (a) =>
              a.profile?._id === agentId ||
              a._id === agentId ||
              a.id === agentId
          );
          if (foundAgent) {
            agentName =
              `${foundAgent.profile?.firstName || foundAgent.firstName || ""} ${
                foundAgent.profile?.lastName || foundAgent.lastName || ""
              }`.trim() || "Unknown Agent";
          }
        }

        // Also check other possible agent locations
        if (!agentId && transaction.agentId) {
          agentId = transaction.agentId;
        }
        if (!agentId && transaction.transactionData?.agent) {
          if (typeof transaction.transactionData.agent === "object") {
            agentId =
              transaction.transactionData.agent._id ||
              transaction.transactionData.agent.id;
          } else {
            agentId = transaction.transactionData.agent;
          }
        }
        if (!agentId && transaction.transactionData?.changes?.agent) {
          if (typeof transaction.transactionData.changes.agent === "object") {
            agentId =
              transaction.transactionData.changes.agent._id ||
              transaction.transactionData.changes.agent.id;
          } else {
            agentId = transaction.transactionData.changes.agent;
          }
        }

        if (
          agentId &&
          transaction.transactionData?.changes?.transactionAmount
        ) {
          const amount = parseFloat(
            transaction.transactionData.changes.transactionAmount
          );
          if (!isNaN(amount) && transaction.transactionType !== "Withdrawal") {
            if (!agentStats[agentId]) {
              agentStats[agentId] = {
                agentName,
                totalAmount: 0,
                transactionCount: 0,
              };
            }
            agentStats[agentId].totalAmount += amount;
            agentStats[agentId].transactionCount += 1;
          }
        }
      });

      return Object.values(agentStats).sort(
        (a, b) => b.totalAmount - a.totalAmount
      );
    },

    // Chart series data for agent performance
    chartSeries() {
      return [
        {
          name: "Collections (GHS)",
          data: this.agentPerformanceData.map((agent) => agent.totalAmount),
        },
      ];
    },

    // Chart options configuration
    chartOptions() {
      const cutoffAmount = 5000;

      return {
        chart: {
          type: "bar",
          height: 400,
          toolbar: {
            show: true,
            tools: {
              download: true,
              selection: false,
              zoom: false,
              zoomin: false,
              zoomout: false,
              pan: false,
              reset: false,
            },
          },
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "55%",
            endingShape: "rounded",
            borderRadius: 4,
            distributed: true,
          },
        },
        dataLabels: {
          enabled: true,
          formatter: function (val) {
            return "GHS " + val.toLocaleString();
          },
        },
        stroke: {
          show: true,
          width: 2,
          colors: ["transparent"],
        },
        xaxis: {
          categories: this.agentPerformanceData.map((agent) => agent.agentName),
          title: {
            text: "Agents",
          },
          labels: {
            rotate: -45,
            maxHeight: 120,
          },
        },
        yaxis: {
          title: {
            text: "Amount Collected (GHS)",
          },
          labels: {
            formatter: function (val) {
              return "GHS " + val.toLocaleString();
            },
          },
        },
        fill: {
          opacity: 1,
        },
        tooltip: {
          y: {
            formatter: function (val, opts) {
              const status =
                val >= cutoffAmount ? "Above Target" : "Below Target";
              const agentData = this.agentPerformanceData[opts.dataPointIndex];
              return `GHS ${val.toLocaleString()} (${status})<br/>Transactions: ${
                agentData?.transactionCount || 0
              }`;
            }.bind(this),
          },
        },
        title: {
          text: "Filtered Agent Performance",
          align: "left",
          style: {
            fontSize: "16px",
            fontWeight: "bold",
            color: "#495057",
          },
        },
        colors: this.agentPerformanceData.map((agent) =>
          agent.totalAmount >= cutoffAmount ? "#28a745" : "#dc3545"
        ),
        legend: {
          show: false,
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200,
              },
            },
          },
        ],
      };
    },

    // Agent statistics for summary cards
    agentsAboveTarget() {
      return this.agentPerformanceData.filter(
        (agent) => agent.totalAmount >= 5000
      ).length;
    },

    agentsBelowTarget() {
      return this.agentPerformanceData.filter(
        (agent) => agent.totalAmount < 5000
      ).length;
    },
  },
  watch: {
    selectedAgents: {
      handler() {
        // Agent selection changed - filtering will be automatically triggered
      },
      deep: true,
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.items.length;
    this.getTodaysTransactions(); // Load today's transactions by default
    this.getAgents(); // Load agents for filtering
  },
  methods: {
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    async getTransactions() {
      this.loading = true;
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_BASE_URL}/admin-transaction/?limit=100&page=1`
        );
        this.transactions = response.data.data.reverse();
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    async getTodaysTransactions() {
      this.loading = true;
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_BASE_URL}/admin-transaction/today`
        );
        this.transactions = response.data.reverse();
        this.loading = false;
      } catch (error) {
        console.log(error);
        this.loading = false;
      }
    },
    async getAgents() {
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_BASE_URL}/admin/users/list-agents?page=1&limit=50&sortBy`
        );
        this.agents = response.data.data || response.data || [];
      } catch (error) {
        console.log("Error fetching agents:", error);
        this.agents = [];
      }
    },
    formatDate(dd) {
      // Parse the original date string
      const originalDate = new Date(dd);

      const year = originalDate.getFullYear();
      const month = originalDate.getMonth() + 1;
      const day = originalDate.getDate();

      // Format the date in "YYYY-MM-DD" format
      const formattedDate = `${year}-${month.toString().padStart(2, "0")}-${day
        .toString()
        .padStart(2, "0")}`;

      return formattedDate; // Output: "2023-10-22"
    },

    async getTransactionsByDate() {
      this.loading = true;
      try {
        const response = await axios.get(
          `${
            process.env.VUE_APP_BASE_URL
          }/admin-transaction/filter?startDate=${this.formatDate(
            this.dateRange[0]
          )}&endDate=${this.formatDate(this.dateRange[1])}`
        );
        this.transactions = response.data;
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    // Method to clear all filters and show all transactions
    showAllTransactions() {
      this.selectedAgents = [];
      this.searchQuery = "";
      this.selectedValues = [];
      this.individualOrGroup = [];
      this.paymentType = [];
      this.getTransactions();
    },

    // Method to show only today's transactions
    showTodaysTransactions() {
      this.selectedAgents = [];
      this.searchQuery = "";
      this.selectedValues = [];
      this.individualOrGroup = [];
      this.paymentType = [];
      this.getTodaysTransactions();
    },

    // Toggle chart visibility
    toggleChart() {
      this.showChart = !this.showChart;
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row" v-if="loading">
      <b-spinner class="m-2 m-auto" variant="primary" role="status"></b-spinner>
    </div>
    <div class="row" v-else>
      <div class="col-12 col-md-12">
        <div class="row">
          <div class="col-md-4">
            <div class="card">
              <div class="card-body">
                <div class="media">
                  <div class="media-body overflow-hidden">
                    <p class="text-truncate font-size-14 mb-2">
                      Number of Transactions
                    </p>
                    <h4 class="mb-0">{{ filterCustomer.length }}</h4>
                  </div>
                  <div class="text-primary">
                    <i class="ri-admin-line font-size-24"></i>
                  </div>
                </div>
              </div>

              <div class="card-body border-top py-3">
                <div class="text-truncate">
                  <span class="badge badge-soft-success font-size-11">
                    <i class="mdi mdi-menu-up"></i>
                    {{ filterCustomer.length }}
                  </span>
                  <span class="text-muted ml-2">Number of Transactions</span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="card">
              <div class="card-body">
                <div class="media">
                  <div class="media-body overflow-hidden">
                    <p class="text-truncate font-size-14 mb-2">
                      Total loans collected
                    </p>
                    <h4 class="mb-0">
                      GHS {{ calculateTransactions.toFixed(2) }}
                    </h4>
                  </div>
                  <div class="text-primary">
                    <i class="ri-wallet-3-line font-size-24"></i>
                  </div>
                </div>
              </div>

              <div class="card-body border-top py-3">
                <div class="text-truncate">
                  <span class="badge badge-soft-success font-size-11">
                    <i class="mdi mdi-menu-up"></i>
                    GHS {{ calculateTransactions.toFixed(2) }}
                  </span>
                  <span class="text-muted ml-2">Total loans collected </span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="card">
              <div class="card-body">
                <div class="media">
                  <div class="media-body overflow-hidden">
                    <p class="text-truncate font-size-14 mb-2">
                      Momo Loan Payments
                    </p>
                    <h4 class="mb-0">GHS {{ momoTransactions.toFixed(2) }}</h4>
                  </div>
                  <div class="text-primary">
                    <i class="ri-cash-fill font-size-24"></i>
                  </div>
                </div>
              </div>

              <div class="card-body border-top py-3">
                <div class="text-truncate">
                  <span class="badge badge-soft-success font-size-11">
                    <i class="mdi mdi-menu-up"></i>
                    GHS {{ momoTransactions.toFixed(2) }}
                  </span>
                  <span class="text-muted ml-2">Momo</span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="card">
              <div class="card-body">
                <div class="media">
                  <div class="media-body overflow-hidden">
                    <p class="text-truncate font-size-14 mb-2">
                      Cash Loan Payments
                    </p>
                    <h4 class="mb-0">GHS {{ cashTransactions.toFixed(2) }}</h4>
                  </div>
                  <div class="text-primary">
                    <i class="ri-cash-line font-size-24"></i>
                  </div>
                </div>
              </div>

              <div class="card-body border-top py-3">
                <div class="text-truncate">
                  <span class="badge badge-soft-success font-size-11">
                    <i class="mdi mdi-menu-up"></i>
                    GHS {{ cashTransactions.toFixed(2) }}
                  </span>
                  <span class="text-muted ml-2">Cash</span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="card">
              <div class="card-body">
                <div class="media">
                  <div class="media-body overflow-hidden">
                    <p class="text-truncate font-size-14 mb-2">Withdrawals</p>
                    <h4 class="mb-0">GHS {{ cashWithdrawals.toFixed(2) }}</h4>
                  </div>
                  <div class="text-primary">
                    <i class="ri-cash-line font-size-24"></i>
                  </div>
                </div>
              </div>

              <div class="card-body border-top py-3">
                <div class="text-truncate">
                  <span class="badge badge-soft-success font-size-11">
                    <i class="mdi mdi-menu-up"></i>
                    GHS {{ cashWithdrawals.toFixed(2) }}
                  </span>
                  <span class="text-muted ml-2">Cash</span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="card">
              <div class="card-body">
                <div class="media">
                  <div class="media-body overflow-hidden">
                    <p class="text-truncate font-size-14 mb-2">
                      Security Deposits
                    </p>
                    <h4 class="mb-0">GHS {{ cashCollaterals.toFixed(2) }}</h4>
                  </div>
                  <div class="text-primary">
                    <i class="ri-cash-line font-size-24"></i>
                  </div>
                </div>
              </div>

              <div class="card-body border-top py-3">
                <div class="text-truncate">
                  <span class="badge badge-soft-success font-size-11">
                    <i class="mdi mdi-menu-up"></i>
                    GHS {{ cashCollaterals.toFixed(2) }}
                  </span>
                  <span class="text-muted ml-2">Security Deposit</span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl-12 col-lg-12">
            <div class="card">
              <div class="card-header bg-transparent border-bottom">
                <h5 class="mb-0">Filters</h5>
              </div>

              <div class="card-body">
                <div
                  class="d-flex justify-content-between align-items-center mb-3"
                >
                  <h5 class="font-size-14 mb-0">Filter By :</h5>
                  <div class="btn-group" role="group">
                    <button
                      type="button"
                      class="btn btn-outline-primary btn-sm"
                      @click="showTodaysTransactions"
                    >
                      <i class="mdi mdi-calendar-today mr-1"></i>Today's
                      Transactions
                    </button>
                    <button
                      type="button"
                      class="btn btn-outline-secondary btn-sm"
                      @click="showAllTransactions"
                    >
                      <i class="mdi mdi-calendar-multiple mr-1"></i>All
                      Transactions
                    </button>
                    <button
                      type="button"
                      class="btn btn-outline-info btn-sm"
                      @click="toggleChart"
                    >
                      <i
                        class="mdi mr-1"
                        :class="
                          showChart ? 'mdi-chart-bar-stacked' : 'mdi-chart-bar'
                        "
                      ></i>
                      {{ showChart ? "Hide Chart" : "Show Chart" }}
                    </button>
                  </div>
                </div>

                <div
                  id="accordion"
                  class="custom-accordion categories-accordion mb-3"
                >
                  <div class="categories-group-card">
                    <a v-b-toggle.electorinic class="categories-group-list">
                      <i
                        class="mdi mdi-account-star-outline font-size-16 align-middle mr-2"
                      ></i>
                      Customer Name
                      <i class="mdi mdi-minus float-right accor-plus-icon"></i>
                    </a>

                    <b-collapse
                      id="electorinic"
                      data-parent="#accordion"
                      accordion="my-accordion"
                    >
                      <div class="search-box ml-2 mt-4 mb-4">
                        <div class="position-relative">
                          <input
                            type="text"
                            class="form-control rounded"
                            v-model="searchQuery"
                            placeholder="Customer Name..."
                          />
                          <i class="mdi mdi-magnify search-icon"></i>
                        </div>
                      </div>
                    </b-collapse>
                  </div>

                  <div class="categories-group-card">
                    <a
                      v-b-toggle.trans
                      class="categories-group-list"
                      data-toggle="collapse"
                      aria-expanded="true"
                      aria-controls="collapseTwo"
                    >
                      <i
                        class="mdi mdi-account-group-outline font-size-16 align-middle mr-2"
                      ></i>
                      Individual/Group
                      <i class="mdi mdi-minus float-right accor-plus-icon"></i>
                    </a>
                    <b-collapse
                      id="trans"
                      visible
                      data-parent="#accordion"
                      accordion="my-accordion"
                    >
                      <div>
                        <div
                          class="custom-control custom-checkbox mb-4 mt-4 ml-1"
                        >
                          <input
                            type="checkbox"
                            class="custom-control-input"
                            id="customCheck7"
                            v-model="individualOrGroup"
                            value="Individual"
                          />
                          <label class="custom-control-label" for="customCheck7"
                            >Individual</label
                          >
                        </div>
                        <div
                          class="custom-control custom-checkbox mb-4 mt-4 ml-1"
                        >
                          <input
                            type="checkbox"
                            class="custom-control-input"
                            id="customCheck6"
                            value="Group"
                            v-model="individualOrGroup"
                          />
                          <label class="custom-control-label" for="customCheck6"
                            >Group</label
                          >
                        </div>
                      </div>
                    </b-collapse>
                  </div>

                  <div class="categories-group-card">
                    <a
                      v-b-toggle.fashion
                      class="categories-group-list"
                      data-toggle="collapse"
                      aria-expanded="true"
                      aria-controls="collapseTwo"
                    >
                      <i
                        class="mdi mdi-cash font-size-16 align-middle mr-2"
                      ></i>
                      Transaction Type
                      <i class="mdi mdi-minus float-right accor-plus-icon"></i>
                    </a>
                    <b-collapse
                      id="fashion"
                      visible
                      data-parent="#accordion"
                      accordion="my-accordion"
                    >
                      <div>
                        <div
                          class="custom-control custom-checkbox mb-4 mt-4 ml-1"
                        >
                          <input
                            type="checkbox"
                            class="custom-control-input"
                            id="customCheck1"
                            v-model="selectedValues"
                            value="SavingsDeposit"
                          />
                          <label class="custom-control-label" for="customCheck1"
                            >Security Deposit</label
                          >
                        </div>
                        <div
                          class="custom-control custom-checkbox mb-4 mt-4 ml-1"
                        >
                          <input
                            type="checkbox"
                            class="custom-control-input"
                            id="customCheck2"
                            value="LoanPayment"
                            v-model="selectedValues"
                          />
                          <label class="custom-control-label" for="customCheck2"
                            >Loan Payment</label
                          >
                        </div>
                      </div>
                    </b-collapse>
                  </div>

                  <div class="categories-group-card">
                    <a
                      v-b-toggle.kids
                      class="categories-group-list collapsed"
                      data-toggle="collapse"
                      aria-expanded="false"
                      aria-controls="collapseThree"
                    >
                      <i
                        class="mdi mdi-account-cash-outline font-size-16 align-middle mr-2"
                      ></i>
                      Payment Type
                      <i class="mdi mdi-minus float-right accor-plus-icon"></i>
                    </a>
                    <b-collapse
                      id="kids"
                      data-parent="#accordion"
                      accordion="my-accordion"
                    >
                      <div>
                        <div
                          class="custom-control custom-checkbox mb-4 mt-4 ml-1"
                        >
                          <input
                            type="checkbox"
                            class="custom-control-input"
                            id="customCheck3"
                            v-model="paymentType"
                            value="1"
                          />
                          <label class="custom-control-label" for="customCheck3"
                            >Cash Payment</label
                          >
                        </div>
                        <div
                          class="custom-control custom-checkbox mb-4 mt-4 ml-1"
                        >
                          <input
                            type="checkbox"
                            v-model="paymentType"
                            class="custom-control-input"
                            id="customCheck4"
                            value="2"
                          />
                          <label class="custom-control-label" for="customCheck4"
                            >Momo Payment</label
                          >
                        </div>
                      </div>
                    </b-collapse>
                  </div>

                  <div class="categories-group-card">
                    <a
                      v-b-toggle.agents
                      class="categories-group-list collapsed"
                      data-toggle="collapse"
                      aria-expanded="false"
                      aria-controls="collapseAgents"
                    >
                      <i
                        class="mdi mdi-account-multiple font-size-16 align-middle mr-2"
                      ></i>
                      Filter by Agent
                      <i class="mdi mdi-minus float-right accor-plus-icon"></i>
                    </a>
                    <b-collapse
                      id="agents"
                      data-parent="#accordion"
                      accordion="my-accordion"
                    >
                      <div>
                        <!-- Debug info -->
                        <div
                          v-if="agents.length === 0"
                          class="text-muted ml-1 mt-3 mb-3"
                        >
                          <small
                            >No agents loaded. Check console for API
                            response.</small
                          >
                        </div>
                        <div v-else class="text-success ml-1 mt-3 mb-3">
                          <small>{{ agents.length }} agents loaded</small>
                        </div>

                        <div
                          v-for="agent in agents"
                          :key="agent.profile?._id || agent._id || agent.id"
                          class="custom-control custom-checkbox mb-3 mt-3 ml-1"
                        >
                          <input
                            type="checkbox"
                            class="custom-control-input"
                            :id="`agent-${
                              agent.profile?._id || agent._id || agent.id
                            }`"
                            v-model="selectedAgents"
                            :value="agent.profile?._id || agent._id || agent.id"
                          />
                          <label
                            class="custom-control-label"
                            :for="`agent-${
                              agent.profile?._id || agent._id || agent.id
                            }`"
                          >
                            {{
                              agent.profile?.firstName ||
                              agent.firstName ||
                              "Unknown"
                            }}
                            {{
                              agent.profile?.lastName ||
                              agent.lastName ||
                              "Agent"
                            }}
                            <small class="text-muted"
                              >(ID:
                              {{
                                agent.profile?._id || agent._id || agent.id
                              }})</small
                            >
                          </label>
                        </div>
                      </div>
                    </b-collapse>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Agent Performance Chart -->
        <div class="row" v-if="showChart && agentPerformanceData.length > 0">
          <div class="col-12">
            <div class="card">
              <div class="card-header bg-transparent border-bottom">
                <div class="d-flex justify-content-between align-items-center">
                  <h5 class="mb-0">
                    <i class="mdi mdi-chart-bar text-primary mr-2"></i>
                    Agent Performance Analytics
                  </h5>
                  <div class="text-muted">
                    <small
                      >Based on current filters •
                      {{ agentPerformanceData.length }} agents</small
                    >
                  </div>
                </div>
              </div>
              <div class="card-body">
                <div class="row mb-3">
                  <div class="col-md-3">
                    <div class="text-center p-3 border rounded">
                      <h6 class="text-muted mb-1">Top Performer</h6>
                      <h5 class="mb-0 text-success">
                        {{ agentPerformanceData[0]?.agentName || "N/A" }}
                      </h5>
                      <small class="text-muted">
                        GHS
                        {{
                          agentPerformanceData[0]?.totalAmount.toLocaleString() ||
                          "0"
                        }}
                      </small>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="text-center p-3 border rounded">
                      <h6 class="text-muted mb-1">Worst Performer</h6>
                      <h5 class="mb-0 text-danger">
                        {{
                          agentPerformanceData[agentPerformanceData.length - 1]
                            ?.agentName || "N/A"
                        }}
                      </h5>
                      <small class="text-muted">
                        GHS
                        {{
                          agentPerformanceData[
                            agentPerformanceData.length - 1
                          ]?.totalAmount.toLocaleString() || "0"
                        }}
                      </small>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="text-center p-3 border rounded">
                      <h6 class="text-muted mb-1">Above Target</h6>
                      <h5 class="mb-0 text-success">
                        {{ agentsAboveTarget }}
                      </h5>
                      <small class="text-muted">agents</small>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="text-center p-3 border rounded">
                      <h6 class="text-muted mb-1">Below Target</h6>
                      <h5 class="mb-0 text-danger">
                        {{ agentsBelowTarget }}
                      </h5>
                      <small class="text-muted">agents</small>
                    </div>
                  </div>
                </div>
                <apexchart
                  type="bar"
                  height="400"
                  :options="chartOptions"
                  :series="chartSeries"
                ></apexchart>
              </div>
            </div>
          </div>
        </div>

        <!-- No Data Message for Chart -->
        <div class="row" v-if="showChart && agentPerformanceData.length === 0">
          <div class="col-12">
            <div class="card">
              <div class="card-body text-center py-5">
                <i
                  class="mdi mdi-chart-bar-stacked text-muted"
                  style="font-size: 3rem"
                ></i>
                <h5 class="mt-3 text-muted">No Data Available</h5>
                <p class="text-muted mb-0">
                  No agent performance data found for the current filters.<br />
                  Try adjusting your filters or selecting different
                  transactions.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Data Table</h4>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-right"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ml-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <div
              class="d-flex justify-content-center align-items-center mt-4 mb-4"
            >
              <div>
                <p></p>
              </div>
              <div class="col-md-6 col-sm-12 row">
                <date-picker
                  v-model="dateRange"
                  type="date"
                  range
                  placeholder="Select date range"
                ></date-picker>
              </div>
              <div>
                <b-button
                  size="sm"
                  variant="secondary"
                  @click.prevent="getTransactionsByDate"
                  >Submit</b-button
                >
              </div>
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                :items="transactionsForTable"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template v-slot:cell(paymentTypeId)="row">
                  <div
                    v-if="row.value == 1"
                    class="badge badge-soft-success font-size-12"
                  >
                    Cash Payment
                  </div>
                  <div
                    v-if="row.value == 2"
                    class="badge badge-soft-warning font-size-12"
                  >
                    Momo Payment
                  </div>
                </template>
                <template v-slot:cell(transactionType)="row">
                  <div
                    v-if="row.value == 'LoanPayment'"
                    class="badge badge-success font-size-12"
                  >
                    Loan Payment
                  </div>
                  <div
                    v-if="row.value == 'SavingsDeposit'"
                    class="badge badge-warning font-size-12"
                  >
                    Security Deposit
                  </div>
                  <div
                    v-if="row.value == 'Withdrawal'"
                    class="badge badge-danger font-size-12"
                  >
                    Withdrawal
                  </div>
                </template>
                <template v-slot:cell(notified)="row">
                  <div
                    v-if="row.value == true"
                    class="badge badge-soft-success font-size-12"
                  >
                    Message Sent
                  </div>
                  <div
                    v-if="row.value == false"
                    class="badge badge-soft-danger font-size-12"
                  >
                    Failed
                  </div>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-right"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
